if (process.env.NODE_ENV === 'staging') {
    (function(src) {
        var a = document.createElement("script");
        a.type = "text/javascript";
        a.async = true;
        a.src = src;
        var b = document.getElementsByTagName("script")[0];
        b.parentNode.insertBefore(a, b)
    })("//sandbox.piano.io/xbuilder/experience/load?aid=vFakxD75su");
}

